<template>
  <div class="sp-expandable-list-item">
    <slot />
  </div>
</template>

<script setup>
/**
 * The ExpandableListItem component is used to display a list item that can be expanded or collapsed.
 * @displayName SPExpandableListItem
 * @group Custom Elements
 * @component sp-expandable-list-item
 */
defineOptions({
  inheritAttrs: false,
});
</script>

<style lang="scss" scoped>
.sp-expandable-list-item {
  &::after {
    content: var(--sp-comp-expandable-list-item-separator, "");
  }
}
</style>
